import { useState } from 'react'
import { notTrackedCopy } from '../ceoCockpitModel'
import { CFO_EVENTS, CFO_SURFACES } from '../../cfoTelemetry'
import { useAnalytics } from '../../../../../analytics'

export type CeoNotTrackedStateProps = {
  title?: string
  connectTarget: string | null | undefined
  onAsk?: (prompt: string) => void
}

export function CeoNotTrackedState({ title, connectTarget, onAsk }: CeoNotTrackedStateProps) {
  const [open, setOpen] = useState(false)
  const analytics = useAnalytics()
  const copy = notTrackedCopy(connectTarget)
  const heading = title || copy.title
  return (
    <div className="ceo-not-tracked" data-testid="ceo-not-tracked">
      <h3>{heading}</h3>
      <p>{copy.sentence}</p>
      <div className="ceo-not-tracked-ctas">
        <button
          type="button"
          onClick={() => {
            setOpen((value) => !value)
            analytics.track({
              event: CFO_EVENTS.ceoNotTrackedCta,
              surface: CFO_SURFACES.ceo,
              props: { connect_target: connectTarget || null, cta: 'how_to_feed' },
            })
          }}
        >
          How to feed it
        </button>
        <button
          type="button"
          onClick={() => {
            analytics.track({
              event: CFO_EVENTS.ceoNotTrackedCta,
              surface: CFO_SURFACES.ceo,
              props: { connect_target: connectTarget || null, cta: 'ask' },
            })
            onAsk?.(`How do I start tracking ${heading.replace(/ is not tracked yet$/i, '')} in QuickBooks so it shows up on the CEO cockpit?`)
          }}
        >
          Ask FuseGrid
        </button>
      </div>
      {open ? (
        <ol>
          {copy.steps.map((step) => (
            <li key={step}>{step}</li>
          ))}
        </ol>
      ) : null}
    </div>
  )
}
